module.exports = __webpack_public_path__ + "static/img/90114G_1_V_20201118_LC.b0ce0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/90114G_1_V_20201118_LC.png
// module id = WF3d
// module chunks = 0